(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hotspots"] && !Shopify.designMode) return;
  try {
    
function sdelfiaBuildLookCarousel() {
  if (Shopify.designMode) return;
  const panels = [...document.querySelectorAll('[data-sd-look]')].filter(p => !p.closest('.sd-look-carousel'));
  if (panels.length < 2) return;
  const root = document.createElement('section');
  root.className = 'sd-look-carousel';
  root.setAttribute('aria-roledescription', 'carousel');
  const title = document.createElement('h2');
  title.className = 'sd-look-carousel__heading';
  title.textContent = panels[0].dataset.sdHeading;
  root.setAttribute('aria-label', title.textContent);
  const slides = document.createElement('div');
  slides.className = 'sd-look-carousel__slides';
  const controls = document.createElement('div');
  controls.className = 'sd-look-carousel__controls';
  const previous = document.createElement('button');
  previous.type = 'button'; previous.textContent = '←';
  previous.setAttribute('aria-label', panels[0].dataset.sdPrevious);
  const next = document.createElement('button');
  next.type = 'button'; next.textContent = '→';
  next.setAttribute('aria-label', panels[0].dataset.sdNext);
  const label = document.createElement('span');
  label.className = 'sd-look-carousel__label';
  label.setAttribute('aria-live', 'polite');
  controls.append(previous, label, next);
  root.append(title, slides, controls);
  panels[0].closest('.shopify-section').before(root);
  const sections = panels.map(panel => panel.closest('.shopify-section'));
  sections.forEach((section, index) => {
    section.setAttribute('role', 'group');
    section.setAttribute('aria-label', panels[index].dataset.sdLook);
    slides.append(section);
  });
  let current = 0;
  const show = index => {
    current = (index + sections.length) % sections.length;
    sections.forEach((section, i) => {
      section.hidden = i !== current;
      section.inert = i !== current;
    });
    label.textContent = panels[current].dataset.sdLook + ' · ' + (current + 1) + '/' + sections.length;
  };
  previous.addEventListener('click', () => show(current - 1));
  next.addEventListener('click', () => show(current + 1));
  root.addEventListener('keydown', event => {
    if (event.target !== previous && event.target !== next) return;
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
  });
  show(0);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sdelfiaBuildLookCarousel, {once: true});
else sdelfiaBuildLookCarousel();

  } catch(e) { console.error(e); }
})();
})();
